module.exports = {
  "country": "LU",
  "artist": "Vicky Leandros",
  "song": "L'amour est bleu",
  "year": "1967",
  "place": "4",
  "spotify": "3Ep59uB8HOpohnKnU57NPU"
};